import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  ControlledTextField,
  ControlledMaskedTextField,
  Fieldset,
  RequiredIndicator,
  TCPA,
} from '@components';
import { useStore } from '@stores';

import { PassthroughParams } from './PassthroughParams';

export const ContactInfoSubModule = () => {
  const { t } = useTranslation('subModules/contactInfo');
  const { formStore } = useStore();
  const currentSubModules = formStore.getSubmodule || [];

  const shouldShowNameField = !currentSubModules.includes('SUB_NAME');

  return (
    <div>
      <RequiredIndicator />
      <Fieldset label={t('title')}>
        {shouldShowNameField && (
          <ControlledTextField
            disabled
            label={t('name')}
            fieldName={'fullName'}
            data-testid="nameTestId"
          />
        )}

        <ControlledTextField
          label={t('email')}
          placeholder={t('emailPlaceholder')}
          fieldName="email"
          inputMode="email"
          data-testid="emailTestId"
          data-tf-sensitive="false"
          required
        />

        <ControlledMaskedTextField
          label={t('phone')}
          placeholder="(123)456-7890"
          maskType="phone"
          inputMode="tel"
          labelStyle="inner"
          fieldName="phone"
          data-testid="mobileTestId"
          data-tf-sensitive="false"
          required
        />
      </Fieldset>
      <Stack spacing={1.5} mt={1}>
        <TCPA />
        <PassthroughParams />
      </Stack>
    </div>
  );
};
